$(function () {
    Serp.setPDPLinkProvider(function (elem) {
        return elem.closest("div.product-item").children('a.product-item__link').attr("href");
    });
});


var SerpReposition = function () {
    var sticky = $(".searchFilter");
    if ($(window).outerWidth() < 992) {
        sticky.removeAttr("style");
        if ($(".horizontal-serp-filter-wrapper").length > 0) {
            $(".horizontal-serp-filter-wrapper").removeAttr("style");
        }
        return;
    }
    var productListComponent = $(".productListComponent");
    var productListHeight = productListComponent.height();
    if (productListHeight > sticky.height()) {
        var $scrollt = $(document).scrollTop();
        var headerHeight = productListComponent.offset().top;
        var documentHeight = $(document).height();
        var horizontalFilterWrapper = $(".horizontal-serp-filter-wrapper");
        if (horizontalFilterWrapper.length > 0) {
            horizontalFilterWrapper.height(sticky.outerHeight(true));
            headerHeight = horizontalFilterWrapper.offset().top;
        }
        var footerHeight = documentHeight - productListHeight - headerHeight;
        var $fullheight = documentHeight - sticky.height() - footerHeight;
        var windowHeight = $(window).outerHeight();

        let width = (sticky.outerWidth($(".main-page-search-header-container").length === 0));

        let headlineHeight = $("#headline").outerHeight();
        let menuHeight = $(".menu-container").outerHeight();
        if (headlineHeight === undefined || menuHeight === undefined) {
            headlineHeight = 0;
            menuHeight = 0;
        }
        let headlineElement = $("#headline")[0];
        let isBikeHeader = headlineElement && headlineElement.parentElement && headlineElement.parentElement.classList.contains("header-bike");
        let offset = !isBikeHeader ? (headlineHeight + menuHeight) : 0;

        if (($scrollt + offset > headerHeight) && ($scrollt + offset < $fullheight)) {
            sticky.removeAttr("style");
            sticky.css({
                "position": "fixed",
                "width": width !== 0 ? width : "auto",
                "top": isBikeHeader ? 0 : offset,
                "max-height": offset > 150 ? windowHeight - 240 : isBikeHeader ?  windowHeight - 50 : windowHeight - 160,
                "overflow-x": "hidden",
                "overflow-y": "auto"
            });
            //max-height limit sticky filter height on 50px from bottom of screen
        } else {
            sticky.removeAttr("style");
        }

        if ($scrollt + offset > $fullheight) {
            //When page scrolled to the footer - filter scrolls also
            sticky.removeAttr("style");
            sticky.css({
                "position": "fixed",
                "width": width !== 0 ? width : "auto",
                "bottom": windowHeight - (documentHeight - $scrollt - footerHeight)
            });
        }
    } else {
        sticky.removeAttr("style");
    }
};

var SerpStickyFilters = (function ($) {

    function initStickyFilterBox() {
        if (!$(".search-filter-floating-container").length) {
            return;
        }

        $(window).on('resize scroll load', SerpReposition);
    }

    return {
        initStickyFilterBox: initStickyFilterBox
    }
})(jQuery);

$(document).ready(function () {
    SerpStickyFilters.initStickyFilterBox();
});


if ($("#content-tyre-selector-page").length) {
    options = document.getElementsByClassName("facet-wrapper");
    for (var i = 0; i < options.length; i++) {
        option = options[i];
        var obs = new MutationObserver(function (m) {
            m.forEach(function (m) {
                if (m.type == "attributes") {
                    SerpReposition();
                }
            });
        });
        obs.observe(option, {attributes: true});
    }
}
